import { Component, OnInit } from "@angular/core";
import { StorfaDefnyddiwrService } from "src/app/craidd/gwasanaethau/system/storfa-defnyddiwr.service";
import { TenantMath } from "src/app/craidd/modelau/defnyddiwr/rol";
import { FERSIWN_AP } from "src/environments/fersiwn";
import { TeitlTudalenComponent } from "../teitl-tudalen/teitl-tudalen.component";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-adrodd-problem",
    templateUrl: "./adrodd-problem.component.html",
    styleUrls: ["./adrodd-problem.component.scss"],
    imports: [
        TeitlTudalenComponent,
        FaIconComponent,
        TranslatePipe,
    ],
})
export class AdroddProblemComponent implements OnInit {
  enwTenant: string;
  fersiwnAp: string;

  constructor(private storfaDefnyddiwrService: StorfaDefnyddiwrService) {}

  ngOnInit(): void {
    this.enwTenant = this.storfaDefnyddiwrService.nolEnwTenant();
    this.fersiwnAp = FERSIWN_AP;
  }

  nolHrefCymorth(): string {
    if (this.enwTenant === TenantMath.Fflint || this.enwTenant === TenantMath.FflintSmallPlant) {
      return `mailto:DesgGymorth@gwynedd.llyw.cymru?subject=Flintshire County Council - Fleet System Helpdesk Call - Version ${this.fersiwnAp}`;
    } else if (this.enwTenant === TenantMath.Conwy) {
      return `mailto:DesgGymorth@gwynedd.llyw.cymru?subject=Conwy County Borough Council - Fleet System Helpdesk Call - Version ${this.fersiwnAp}`;
    }
    return `mailto:DesgGymorth@gwynedd.llyw.cymru?subject=Cyngor Gwynedd - Galwad Desg Gymorth Asedau Fflyd - Fersiwn ${this.fersiwnAp}`;
  }

  nolLogo(): string {
    return "assets/lluniau/navbar_cg.png";
  }

  nolLogoDatblygu(): string {
    return "assets/lluniau/logo_datblygu.png";
  }

  nolLogoSystem(): string {
    return "assets/lluniau/sidebar_logo.png";
  }
}
